import React from "react";
import './ProductBOM.css'
import ProductBOMOverview from './ProductBOMOverview'
import BannerImage from "../../../assets/other_image/Variability_Management.jpg";
import Letsgetintouch from '../BusinessProcessAndChangeManagement/Letsgetintouch';
import { NavLink } from 'react-router-dom';
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const ProductBOM = () => {
  

  return (
    <>
    <Helmet>
      <title>Teamcenter BOM Management Solutions in Pune | NexTech PLM</title>
      <meta name="description" content="Streamline your product development with NexTech's Teamcenter BOM Management solution. Enhance collaboration, ensure data integrity, and manage complex product structures efficiently across the entire lifecycle." />
      <meta name="keywords" content="Teamcenter BOM management, bill of materials PLM, EBOM MBOM management Pune, product structure management, Teamcenter BOM variability, PLM BOM services India" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href="https://nextechplm.com/teamcenter-bom-management" />
      <meta property="og:site_name" content="NexTech PLM Solutions" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Teamcenter BOM Management Solutions in Pune | NexTech PLM" />
      <meta property="og:description" content="Streamline your product development with NexTech's Teamcenter BOM Management solution. Enhance collaboration and manage complex product structures efficiently." />
      <meta property="og:url" content="https://nextechplm.com/teamcenter-bom-management" />
      <meta property="og:image" content="https://nextechplm.com/logo192.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Teamcenter BOM Management Solutions in Pune | NexTech PLM" />
      <meta name="twitter:description" content="Streamline your product development with NexTech's Teamcenter BOM Management solution. Enhance collaboration and manage complex product structures efficiently." />
      <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
    </Helmet>

    <section className="ProductBOM-management">
       
        <Banner
        image={BannerImage} // Pass the image for this page
        heading="Teamcenter Product BOM-Management" // Pass the heading text for this page
      />
      <div>
         <FloatingContactUs />
      </div>


     
      <ProductBOMOverview/>
      <section style={{ background: "#f5f7fa" }}>
      <div className="benefits container">
      <h4 className="ProductBOM-page-heading">Unlock the Power :</h4>
      <h5 className="ProductBOM-subheading">
        Discover the Transformative Benefits of Product BOM-Management with  NexTech!
      </h5>
      <ul className="custom-bullets">
        <li>Efficiently define, approve, and communicate BOM that can support each functional entity and BOM views </li>
        <li>Improved re-use of Design and Part with Part-CAD alignment  </li>
        <li>
        Manage product variability across the product lifecycle  
        </li>
        <li>Eliminate the BOM manual handoffs and other constraints posed by legacy applications   </li>
      </ul>
    </div>
    </section>
    <section>
  <div className="solutions container">
    <div className="solutions-content">
      <div className="row">
        <div className="col-md-6 col-12">
          <h4 className="ProductBOM-page-heading">Teamcenter Solutions</h4>

          <ul className="custom-bullets">
        <li>BOM Management </li>
        <li>Product Configurator </li>
        <li>Part-CAD Alignment </li>
        <li>EBOM to MBOM Alignment </li>
        <li>End to End Change Management </li>
        <li>Implement BOM Context Management </li>
          </ul>
 
        </div>

        <div className="col-md-6 col-12">
          <div className="quick-links">
            <h4>Quick Links</h4>
            <ul>
            <li><NavLink to={"/teamcenter/community-collaboration"} >Teamcenter Community Collaboration</NavLink></li>
            <li>
                      <NavLink to={"/teamcenter/cybersecurity"}>
                        Teamcenter Cyber security
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to={"/teamcenter/cloud-implementation"}>
                        Teamcenter Implementation on Cloud
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/implementation"}>
                        Teamcenter Implementation
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to={"/teamcenter/cae-integration"}>
                        Teamcenter Integration for CAE
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/cam-integration"}>
                        Teamcenter Integration for CAM
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/teamcenter/performance-tuning-health-checkup"}
                      >
                        Teamcenter Performance Tuning & Health Check-up
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/program-project-management"}>
                        Teamcenter Project Management
                      </NavLink>
                    </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
    <section style={{ background: "#f5f7fa" }}>
    <div className="why-nextech container">
      <h4 className="ProductBOM-page-heading">Why NexTech?</h4>
      <h5 className="ProductBOM-subheading">For  Product BOM and Variability Management</h5>
      <ul className="custom-bullets">
        <li>
        Expertise in implementing Teamcenter BOM management solutions for seamless access and sharing across the product lifecycle and global enterprise.  
        </li>
        <li>
        Deep knowledge in product configuration methods, including variants, effectivities, and revision rules, ensuring comprehensive management of product variability. 
        </li>
        <li>
        Implementation of product configurators to ensure upfront option compatibility and streamline design and part re-use with Part-CAD alignment.  
        </li>
        <li>
        Proficiency in managing product variability throughout the lifecycle, enhancing efficiency and adaptability in changing requirements.   
        </li>
        <li>
        Elimination of manual BOM handoffs and legacy application constraints, ensuring smooth operations and improved collaboration across functions.   
        </li>
      </ul>
    </div>

    </section>
    <Letsgetintouch />
  </section>
  </>
  )
}

export default ProductBOM